import { CommonModule, NgFor, NgStyle } from '@angular/common';
import { Component, NgModule, OnInit, Renderer2 } from '@angular/core';
import { FormControl, FormsModule, NgModel } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgApexchartsModule } from 'ng-apexcharts';
import {
  ApexNonAxisChartSeries,
  ApexChart,
  ApexTitleSubtitle,
  ApexDataLabels,
  ApexPlotOptions,
  ApexFill,
} from 'ng-apexcharts';

import { ToastrModule, ToastrService } from 'ngx-toastr';
import { DashboardService } from '../../../Services/dashboard.service';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { LoaderComponent } from "../../loader/loader.component";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  title: ApexTitleSubtitle;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
};

enum UserType {
  Individual = 1,
  Corporate = 2,
  Dumpster = 3,
  Dumpyard = 4,
}

@Component({
  selector: 'app-registered-users',
  standalone: true,
  imports: [
    NgApexchartsModule,
    FormsModule,
    CommonModule,
    RouterModule,
    NgFor,
    ToastrModule,
    LoaderComponent
],
  templateUrl: './registered-users.component.html',
  styleUrl: './registered-users.component.css',
})
export class RegisteredUsersComponent implements OnInit {
  allCount: any;
  cityList: any;
  zoneList: any;
  selectedCityId: any;
  selectedZoneId: any;
  getFilterCount: any;
  individualCount: any;

  zoneListIndividual: any;
  zoneListCorporate: any;
  zoneListDumpster: any;
  zoneListDumpyard: any;
  isLoading: boolean = false;
  isPageloading: boolean =false;

  constructor(
    private renderer: Renderer2,
    private dashService: DashboardService,
    private masterService: MasterInformationService,
    private toastr: ToastrService
  ) {}

  // -----------------------------------  OnInit ----------------------------------- //

  ngOnInit() {
    this.getAllCount();
    this.getCity();
    this.getInitialList(UserType.Individual);
    this.getInitialList(UserType.Corporate);
    this.getInitialList(UserType.Dumpster);
    this.getInitialList(UserType.Dumpyard);
  }

  // ----------------------------------- Get Initial Chart Count ----------------------------------- //

  getInitialList(userType: any) {
    this.isPageloading = true;
    this.dashService
      .getInitialUsersList(apiEndPoints.registeredDashboardFilter, userType)
      .subscribe({
        next: (response: any) => {
          this.isPageloading = false;
          this.individualCount = response.body.details;
          switch (userType) {
            case UserType.Individual:
              this.chartSeriesIndividual = [
                this.individualCount.onBusinessUserCount,
                this.individualCount.offBusinessUserCount,
              ];
              break;
            case UserType.Corporate:
              this.chartSeriesCorporate = [
                this.individualCount.onBusinessUserCount,
                this.individualCount.offBusinessUserCount,
              ];
              break;
            case UserType.Dumpster:
              this.chartSeriesDumpster = [
                this.individualCount.onBusinessUserCount,
                this.individualCount.offBusinessUserCount,
              ];
              break;
            case UserType.Dumpyard:
              this.chartSeriesDumpyard = [
                this.individualCount.onBusinessUserCount,
                this.individualCount.offBusinessUserCount,
              ];
              break;
          }
        },
      });
  }

  // ----------------------------------- All Dashboard Count ----------------------------------- //

  getAllCount() {
    this.dashService
      .getDashboardList(apiEndPoints.getDashboardDetails)
      .subscribe({
        next: (response: any) => {
          this.allCount = response.body.details;

          this.summaryCards = this.summaryCards.map((card: any) => {
            switch (card.title) {
              case 'City':
                card.count = this.allCount.cityCount;
                break;
              case 'Zones':
                card.count = this.allCount.zoneCount;
                break;
              case 'Registered Users':
                card.count = this.allCount.registeredUsers;
                break;
              case 'Business Users':
                card.onBusinessCount = this.allCount.onBusiness || 0;
                card.offBusinessCount = this.allCount.offBusiness || 0;
                card.count = card.onBusinessCount + card.offBusinessCount;
                break;
              case 'Active business':
                card.count = this.allCount.onBussinessActiveUser;
                break;
              case 'Requestor':
                card.individualCount = this.allCount.individualRequestor || 0;
                card.corporateCount = this.allCount.corporateRequestor || 0;
                card.count = card.individualCount + card.corporateCount;
                break;
              case 'Dumpster':
                card.count = this.allCount.dumpsterCount;
                break;
              case 'Dump Yard':
                card.count = this.allCount.dumpyardCount;
                break;
            }
            return card;
          });
        },
      });
  }

  summaryCards = [
    {
      title: 'City',
      count: '',
      description: 'Counts',
      color: '#E1D7F4',
      icon: 'bi bi-building',
      textColor: '#4B0082',
      route: '/city',
    },
    {
      title: 'Zones',
      count: '',
      description: 'Counts',
      color: '#CCE6FF',
      icon: 'bi bi-map',
      textColor: '#003366',
      route: '/zones',
    },
    {
      title: 'Registered Users',
      count: '',
      description: 'Counts',
      color: '#A7F0E6',
      icon: 'bi bi-person-plus',
      textColor: '#006B5C',
      route: '/on-off-business',
    },
    {
      title: 'Business Users',
      count: '',
      onBusinessCount: '',
      offBusinessCount: '',
      description: 'Counts',
      color: '#F8D7E5',
      icon: 'bi bi-person-check',
      textColor: '#9B1B30',
      route: '/on-off-business',
    },
    {
      title: 'Active business',
      count: '',
      description: 'Counts',
      color: '#F9ECC9',
      icon: 'bi bi-person-check',
      textColor: '#AD870C',
      route: '/on-off-business',
    },
    {
      title: 'Requestor',
      count: '',
      individualCount: '',
      corporateCount: '',
      description: 'Counts',
      color: '#DCFFDDF7',
      icon: 'bi bi-person-badge',
      textColor: '#2D702F',
      route: '/requestor',
    },
    {
      title: 'Dumpster',
      count: '',
      description: 'Counts',
      color: '#e6e6fa',
      icon: 'bi bi-truck',
      textColor: '#4b0082',
      route: '/dumpster',
    },
    {
      title: 'Dump Yard',
      count: '',
      description: 'Counts',
      color: '#F5F5DC',
      icon: 'fa fa-truck-loading',
      textColor: '#8B4513',
      route: '/dumpyard',
    },
  ];

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        console.log('Success --->', response);
        this.cityList = response.body.details;
      },
      error: (error) => {
        console.error('API Error:', error);
        console.error('Error Status:', error.status);
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event, userType: any) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCity;
    this.getZone(userType);
    this.getChartFilterCount(userType);
  }

  // ----------------------------------- Get Zone List API ----------------------------------- //

  getZone(userType: any) {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body.details;

          if (userType === 1) {
            this.zoneListIndividual = this.zoneList;
          } else if (userType === 2) {
            this.zoneListCorporate = this.zoneList;
          } else if (userType === 3) {
            this.zoneListDumpster = this.zoneList;
          } else if (userType === 4) {
            this.zoneListDumpyard = this.zoneList;
          }
        },
        error: (error) => {
          // this.toastr.error(
          //   'An unexpected error occurred zoneeeeeeeeee. Please try again later.',
          //   'Error',
          //   {
          //     timeOut: 3000,
          //     positionClass: 'toast-top-right',
          //     progressBar: true,
          //   }
          // );
        },
      });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event, userType: any) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
    this.getChartFilterCount(userType);
  }

  // ----------------------------------- Get Chart Filter API ----------------------------------- //

  getChartFilterCount(userType: any) {
    this.dashService
      .getDashboardCount(
        apiEndPoints.registeredDashboardFilter,
        this.selectedCityId,
        this.selectedZoneId,
        userType
      )
      .subscribe({
        next: (response: any) => {
          this.getFilterCount = response.body.details;
          if (userType === 1) {
            this.chartSeriesIndividual = [
              this.getFilterCount.onBusinessUserCount,
              this.getFilterCount.offBusinessUserCount,
            ];
          } else if (userType === 2) {
            this.chartSeriesCorporate = [
              this.getFilterCount.onBusinessUserCount,
              this.getFilterCount.offBusinessUserCount,
            ];
          } else if (userType === 3) {
            this.chartSeriesDumpster = [
              this.getFilterCount.onBusinessUserCount,
              this.getFilterCount.offBusinessUserCount,
            ];
          } else if (userType === 4) {
            this.chartSeriesDumpyard = [
              this.getFilterCount.onBusinessUserCount,
              this.getFilterCount.offBusinessUserCount,
            ];
          }
        },
      });
  }

  // ----------------------------------- Chart Series  ----------------------------------- //

  chartSeriesIndividual: ApexNonAxisChartSeries = [];

  chartLabelsIndividual: string[] = ['On Business', 'Off Business']; // Define labels for each segment

  chartOptionsIndividual: ApexChart = {
    type: 'donut', // Donut chart
    height: 300,
  };

  titleIndividual: ApexTitleSubtitle = {
    text: '',
    align: 'left',
  };

  dataLabelsIndividual: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    },
  };

  plotOptionsIndividual: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Registered',
            formatter: (w) =>
              w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0),
          },
        },
      },
    },
  };

  colorsIndividual: string[] = ['#00E396', '#FF4560']; // Custom colors

  fillIndividual: ApexFill = {
    type: 'gradient',
  };

  // ----------------------------------- Chart Series-Corporate  ----------------------------------- //

  chartSeriesCorporate: ApexNonAxisChartSeries = []; // Percentages for each category

  chartLabelsCorporate: string[] = ['On Business', 'Off Business']; // Define labels for each segment

  chartOptionsCorporate: ApexChart = {
    type: 'donut', // Donut chart
    height: 300,
  };

  titleCorporate: ApexTitleSubtitle = {
    text: '',
    align: 'left',
  };

  dataLabelsCorporate: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    },
  };

  plotOptionsCorporate: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Registered',
            formatter: (w) =>
              w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0),
          },
        },
      },
    },
  };

  colorsCorporate: string[] = ['#00E396', '#FF4560', '#00B8D4']; // Custom colors

  fillCorporate: ApexFill = {
    type: 'gradient',
  };

  // ----------------------------------- Chart Series-Dumpster  ----------------------------------- //

  chartSeriesDumpster: ApexNonAxisChartSeries = []; // Percentages for each category

  chartLabelsDumpster: string[] = ['On Business', 'Off Business']; // Define labels for each segment

  chartOptionsDumpster: ApexChart = {
    type: 'donut', // Donut chart
    height: 300,
  };

  titleDumpster: ApexTitleSubtitle = {
    text: '',
    align: 'left',
  };

  dataLabelsDumpster: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    },
  };

  plotOptionsDumpster: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Registered',
            formatter: (w) =>
              w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0),
          },
        },
      },
    },
  };

  colorsDumpster: string[] = ['#00E396', '#FF4560', '#00B8D4']; // Custom colors

  fillDumpster: ApexFill = {
    type: 'gradient',
  };

  // ----------------------------------- Chart Series-Dumpyard  ----------------------------------- //

  chartSeriesDumpyard: ApexNonAxisChartSeries = []; // Percentages for each category

  chartLabelDumpyard: string[] = ['On Business', 'Off Business']; // Define labels for each segment

  chartOptionsDumpyard: ApexChart = {
    type: 'donut', // Donut chart
    height: 300,
  };

  titleDumpyard: ApexTitleSubtitle = {
    text: '',
    align: 'left',
  };

  dataLabelsDumpyard: ApexDataLabels = {
    enabled: true,
    formatter: (val: number, opts: any) => {
      const rawValue = opts.w.globals.series[opts.seriesIndex];
      return rawValue;
    },
  };

  plotOptionsDumpyard: ApexPlotOptions = {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          total: {
            show: true,
            label: 'Registered',
            formatter: (w) =>
              w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0),
          },
        },
      },
    },
  };

  colorsDumpyard: string[] = ['#00E396', '#FF4560', '#00B8D4'];

  fillDumpyard: ApexFill = {
    type: 'gradient',
  };

  cityControl: FormControl = new FormControl('');
  zoneControl: FormControl = new FormControl('');
  cities = ['New York', 'Los Angeles', 'Chicago', 'Houston'];
  zones = ['North Zone', 'South Zone', 'East Zone', 'West Zone'];

  // Selected city and zone
  selectedCity: string = '';
  selectedZone: string = '';
}
